<template>
    <div>
        <div class="row" v-show="loading">
            <div class="text-center col-12 py-3">
                <span class="spinner-border" role="status"></span>
            </div>
        </div>

        <div v-if="!loading">
            <TcElementInfoCard v-if="isOptima" :studentDescriptions="student_descriptions"/>

            <TcElementQuestionCard v-for="(questionCard, index) in questionCards"
                                   :savedAll="savedAll"
                                   :changeable="true"
                                   :questionCard="questionCard"
                                   :key="index"/>

            <div v-if="questionCards.length" style="padding-bottom: 10px">
                <button class="btn btn-success fw-bold btn-block px-4" @click="save" :disabled="isSaving">
                    <span v-if="!isSaving">{{ $t('Lagre') }}</span>
                    <span v-if="isSaving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </button>
            </div>
            <div v-else class="text-center col-12 my-3 alert alert-info">{{ $t('Du har ingen spørsmål som kan besvares.') }}</div>

            <div v-if="hasSaved" class="alert alert-success">
                <p class="m-0">{{ $t('Lagret') }}</p>
            </div>
            <div v-if="saveFailed" class="alert alert-danger">
                <p class="m-0">{{ saveErrorMessage }}</p>
            </div>

            <div v-if="oldQuestionsLoaded && nonChangeableCards.length">
                <button
                    v-if="questionCards.length"
                    class="form-control"
                    :disabled="loadingOldQuestions"
                    v-text="getToggleText"
                    v-on:click="toggleNonChangeableCards"/>

                <div v-if="showNonChangeableCards">
                    <TcElementQuestionCard v-for="card in nonChangeableCards"
                                       :changeable="false"
                                       :questionCard="card"
                                       :key="card['tc_content_id']"/>
                </div>
            </div>

            <div v-else-if="!oldQuestionsLoaded">
                <button
                    class="form-control"
                    :disabled="loadingOldQuestions"
                    @click="loadOldQuestions">
                    <span v-if="!loadingOldQuestions">{{ $t('Se tidligere besvarte spørsmål') }}</span>
                    <span v-else>
                        <span class="spinner-border spinner-border-sm" role="status"></span>
                        {{ $t('Laster...') }}
                    </span>
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, defineAsyncComponent } from 'vue';
import Api from "../../api/TcElementQuestions";

const questionCards = ref([]);
const nonChangeableCards = ref([]);
const student_descriptions = ref([]);
const isSaving = ref(false);
const hasSaved = ref(false);
const saveFailed = ref(false);
const saveErrorMessage = ref('');
const loading = ref(false);
const loadingOldQuestions = ref(false);
const showNonChangeableCards = ref(false);
const oldQuestionsLoaded = ref(false);
const savedAll = ref(null);

const isOptima = computed(() => window.isOptima);

const getToggleText = computed(() => {
    if (showNonChangeableCards.value) {
        return $t('Skjul tidligere besvarte spørsmål');
    }
    return $t('Se tidligere besvarte spørsmål');
});

const save = () => {
    isSaving.value = true;
    saveFailed.value = false;
    Api.updateAnswers(questionCards.value).then((result) => {
        console.log('result', result);
        if (result['updated_at']) {
            savedAll.value = result['updated_at'];
        }

        isSaving.value = false;
        if (result['success']) {
            hasSaved.value = true;
            questionCards.value.forEach(card => {
                card.questions.forEach(question => {
                    question.updated = false;
                });
            });
            return window.setTimeout(() => {
                hasSaved.value = false;
            }, 5000);
        }

        saveFailed.value = true;
        saveErrorMessage.value = result['message'] ?? $t('Lagring feilet');
        window.setTimeout(() => {
            saveFailed.value = false;
        }, 5000);
    });
};

const toggleNonChangeableCards = () => {
    showNonChangeableCards.value = !showNonChangeableCards.value;
};

const loadOldQuestions = () => {
    loadingOldQuestions.value = true;
    Api.GetOld().then((res) => {
        if (res.success) {
            nonChangeableCards.value = res.data.nonChangeableCards;
            oldQuestionsLoaded.value = true;
            showNonChangeableCards.value = true; // Show them immediately after loading
        }
    }).finally(() => {
        loadingOldQuestions.value = false;
    });
};

onMounted(() => {
    loading.value = true;
    Api.Get().then((res) => {
        if (res.success) {
            questionCards.value = res.data.questionCards;
            student_descriptions.value = res.data.student_descriptions;
        }
    }).finally(() => {
        loading.value = false;
    });
});

const TcElementQuestionCard = defineAsyncComponent(() => import('./TcElementQuestionCard.vue'));
const TcElementInfoCard = defineAsyncComponent(() => import('./TcElementInfoCard.vue'));
</script>
